import { useAtom } from "jotai";

import { ClientSettingColorAtom, useGlobalMMMStore } from "../mmm-provider";

export const useClientSettingsColorMap: () => Record<string, string> = () => {
  const GlobalMMMStore = useGlobalMMMStore();
  const [clientSettingColorMap] = useAtom(ClientSettingColorAtom, {
    store: GlobalMMMStore,
  });
  return clientSettingColorMap;
};
